import { render, staticRenderFns } from "./IdeaSpaceAdmin.vue?vue&type=template&id=2633337c"
import script from "./IdeaSpaceAdmin.vue?vue&type=script&lang=js"
export * from "./IdeaSpaceAdmin.vue?vue&type=script&lang=js"
import style0 from "./IdeaSpaceAdmin.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports